<template>
  <modal @close="modals.billingTopUpModal = false">
      <div v-if="screen === 'form'">
          <h3>Top Up Team Balance</h3>
          <div class="large-form">
              <div class="form-line">
                  <div id="form-field-amount" class="form-field with-prepend" style="width: 60%; float: none;">
                      <label for="form-input-amount">Top Up Amount</label>
                      <!-- <div class="prepend">£</div><input v-model="item.amount" type="number" id="form-input-amount" required="required" min="10" max="1000000" /> -->
                      <select v-model="item.amount" required="required">
                          <option v-for="amount in topUpAmounts" :value="amount" :selected="amount==1000">£ {{ amount }}</option>
                      </select>
                  </div>
              </div>
              
              <div class="form-line" style="margin-top: 30px">
                  <div class="form-field">
                      <label>Price Breakdown</label>
                      <table class="gift-registration-order-summary" style="margin-top: 0">
                          <tbody>
                              <tr>
                                  <td class="name">Top Up Amount</td>
                                  <td class="value">{{ prices.topUp | toCurrency }}</td>
                              </tr>     
                              <tr v-if="item.payment_method=='stripe'">
                                  <td class="name">Card Processing Fee <div class="sub">charged by <span style="font-weight: bold; font-style: normal; letter-spacing: 0; color: #222;">stripe</span> payment gateway</div></td>
                                  <td class="value">
                                      <div v-if="loading" class="value-loader" style="top: -12px"></div>
                                      <div v-else>{{ prices.topUpFee | toCurrency }}</div>
                                  </td>
                              </tr>   
                              <tr class="total">
                                  <td class="name">Total Price To Pay</td>
                                  <td class="value">
                                      <div v-if="loading" class="value-loader" style="top: -12px"></div>
                                      <div v-else>{{ prices.total | toCurrency }}</div>
                                  </td>
                              </tr>  
                          </tbody>
                      </table>
                  </div>
              </div>
              
              <field-payment :item="item" type="top-up" platform="top-up" :prices="prices" @loaded="onPaymentMethodLoad"></field-payment>

              <div class="modal-errors">
                  <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
              </div>
          </div>
          <div class="form-actions">
              <span v-if="userCanCheckout && item.payment_method=='bank-transfer'" class="ws-button ws-button-main" @click="sendTopUpRequest">Request Invoice</span>
              <span v-if="userCanCheckout && item.payment_method=='stripe'" class="ws-button ws-button-main" @click="cardPaymentTopUp">Confirm Top Up</span>
              <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.billingTopUpModal = false">Go Back</span>
          </div>
      </div>
      
      <!-- Payment Processing -->
      <div v-else-if="screen === 'payment'">
          <div class="ws-form-processing"><div class="value-loader"></div><p>We are processing your payment. <br>Please give us a moment...</p></div>
      </div>
      
      <!-- Order Prgcessing -->
      <div v-else-if="screen === 'processing'">
          <div class="ws-form-processing"><div class="value-loader"></div><p>We are processing your top-up request. <br>Please give us a moment...</p></div>
      </div>
      
      <!-- Top Up Request Sent -->
      <div v-else-if="screen === 'top-up-requested'">
          <h3>Top Up Request Sent</h3>
          <div class="ws-form-processing"><p>Your balance top-up request has been received. We will send you an invoice soon. Once we receive your bank transfer, we will top up your account.</p></div>
          <div class="form-actions">
              <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.billingTopUpModal = false">Close</span>
          </div>
      </div>
      
      <!-- Top Up Request Sent -->
      <div v-else-if="screen === 'topped-up'">
          <h3>Top Up Complete</h3>
          <div class="ws-form-processing"><p>We have received your payment and processed your top up request. Your balance has been topped up.</p></div>
          <div class="form-actions">
              <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.billingTopUpModal = false">Close</span>
          </div>
      </div>
      
  </modal>
</template>


<script>
import Modal from "@/components/modals/Modal";
import FieldPayment from "@/components/FieldPayment";

export default {
    name: "BillingTopUpModal",
    components: {Modal,FieldPayment},
    props: {
        teamId: Number,
    },
    data() {
        return {
            item: {amount: 1000, payment_method: 'stripe', payment_method_id: null, payment_id: null},
            prices: {topUp: 0, topUpFee: 0, total: 0},
            errors: {},
            screen: 'form',
            percentageFee: 0.014,
            flatFee: 0.2,
            loading: true,
            eeaCountries: ['AL','AT','BA','BE','BG','CH','CY','DE','DK','EE','ES','FI','FR','GB','GR','HR','HU','IE','IS','IT','LT','LV','MK','MT','NL','NO','PL','PT','RO','RS','SE','SI'],
            topUpAmounts: [50, 100, 200, 300, 500, 750, 1000, 2500, 5000, 10000],
        }
    },
    methods: {
        async updatePrices(refreshFeePercentage = false) {
            this.prices.topUp = this.item.amount;
            if (this.item.payment_method == 'stripe') {
                if (refreshFeePercentage) await this.calculateProcessingFee();
                this.prices.topUpFee = this.calculateTopUpFee(parseFloat(this.item.amount));
            } else this.prices.topUpFee = 0;
            this.prices.total = parseFloat(this.prices.topUp) + parseFloat(this.prices.topUpFee);
            this.loading = false;
        },
        async calculateProcessingFee() {
            this.loading = true;
            const paymentMethod = await this.dispatchWaitAndNotify('fetchStripePaymentMethod',this.item.payment_method_id, false, true);
            if (paymentMethod && paymentMethod.country && this.eeaCountries.includes(paymentMethod.country)) {
                this.percentageFee = 0.014;
            } else {
                this.percentageFee = 0.029;
            }
        },
        calculateTopUpFee(amount) {
            var totalCharge = (amount + this.flatFee) / (1 - this.percentageFee);
            return totalCharge - amount;
        },
        
        async sendTopUpRequest() {
            if (!this.demoCheck()) return;
            
            this.errors = this.validateFields([
                { name: 'Amount', value: this.item.amount, rules: ['required'] },
            ]);
            if (this.errors.length) return;
            this.screen = 'processing';
            await this.dispatchWaitAndNotify('paymentDocumentRequest', {type: 'invoice', message: "I would like to top up our balance by <b>£"+this.item.amount+"</b>. Please create invoice for me."});
            this.screen = 'top-up-requested';
        },
        async cardPaymentTopUp() {
            this.screen = 'payment'; 
            try {
                await this.dispatchWaitAndNotify('postStripePaymentIntent', {
                    'payment_method_id': this.item.payment_method_id,
                    'raw_amount': this.prices.topUp,
                    'amount': this.prices.total,
                    'description': 'Bookblock HUB Pro TOP-UP',
                    'suffix': 'TOP-UP',
                    'create_transaction': true,
                }, false, true);
                this.item.payment_id = this.paymentIntentResult.payment_intent_id;
            }  catch (e) {
                this.screen = 'form';
                return;
            }
            this.dispatchWaitAndNotify('fetchTeam', null,  false, true);
            if (this.user.permissions.includes('team-finance')) this.dispatchWaitAndNotify('fetchRecentTransactions', null, false, true);
            this.dispatchWaitAndNotify('fetchRecentDirectTransactions', null, false, true);
            this.screen = 'topped-up';
        },
        async onPaymentMethodLoad() {
            
        }
    },
    mounted() {	
        if (!this.proCheck('Adding and using team credit')) {
            this.modals.billingTopUpModal = false;
            return;
        }
        this.updatePrices();	
	},
    computed: {
        user() {
            return this.$store.state.currentUser;
        },
        team() {
            return this.$store.state.team.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        paymentIntentResult() {
            return this.$store.state.transaction.paymentIntentResult;
        },
        userCanCheckout() {
            return this.user.permissions && (this.user.permissions.includes('use-balance') || this.user.permissions.includes('use-cards')) && (this.item.payment_method=='bank-transfer' || this.item.payment_method_id) && !this.loading;
        },
    },
    watch: {
        'item.amount': {
			handler (value) {
				this.updatePrices();
			},
		},
        'item.payment_method': {
			handler (value) {
				this.updatePrices();
			},
		},
        'item.payment_method_id': {
			handler (value) {
				this.updatePrices(true);
			},
		},
    },
    
}
</script>

<style scoped>

</style>